// extracted by mini-css-extract-plugin
export default {"enableLaunchPanelDescription":"GeneralForm_enableLaunchPanelDescription__CaYpU"};